module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7e9fd4a23990a7a8f94c59c2671ecd62.png";